import { VDatePicker } from 'vuetify/lib/components/VDatePicker';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rcc-datepicker"},[_c(VDatePicker,{attrs:{"locale":"ru","range":_vm.isRange,"selected-items-text":"Диапазон дат"},model:{value:(_vm.selectedDates),callback:function ($$v) {_vm.selectedDates=$$v},expression:"selectedDates"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }